import { SET_COUNTIES, SET_ACCOUNT_TYPES, SET_ROUTING_TYPES } from './actionTypes';

let initialState = {
    countries: [],
    accountTypes: null,
    routingTypes: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_COUNTIES:
            return {
                ...state,
                countries: action.payload || []
            };
        case SET_ACCOUNT_TYPES:
            return {
                ...state,
                accountTypes: action.payload || null
            };
        case SET_ROUTING_TYPES:
            return {
                ...state,
                routingTypes: action.payload || null
            };
        default:
            break;
    }
    return state;
};

export default reducer;

